import Wrapper from "../../layout/wrapper/Wrapper";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/submit.module.scss";
import styles1 from "../../styles/pages/submithome.module.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import SubmitHeader from "../../components/SubmitHeader/SubmitHeader";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useQuery } from "react-query";
import { FetchSubmitedVideos } from "../../api/functions/submited.videos.api";

import ApiLoader from "../../components/Loaders/ApiLoader";
import SubmittedDuplicateTableTwo from "../../components/AllTable/SubmittedPageVideos/SubmittedDuplicateTableTwo";

function Duplications() {
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const { duplicates, from, to } = useAppSelector(
    (s) => s.submittedDuplicationSlice
  );

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(["duplication"], async () =>
    FetchSubmitedVideos({
      page,
      from,
      to,
      // duplicate: duplicates,
      status: 6,
    })
  );

  const handlePageChange = (p) => {
    setPage(p);
  };

  useEffect(() => {
    refetchAgain();
  }, [page, fetchTrigger]);

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  return (
    <Wrapper>
      <ApiLoader loading={isLoading} />
      <Box className="main_body">
        <SubmitHeader />

        <Box className={styles.submitPageWrapper}>
          <Box className={styles1.submitTable}>
            <SubmittedDuplicateTableTwo
              datas={data?.data}
              handlePageChange={handlePageChange}
              page={page}
              handleTriggreFetch={handleTriggreFetch}
              p={{
                openFilterModal,
                setOpenFilterModal,
                handleTriggreFetch,
              }}
              loading={isLoading}
            />
          </Box>
        </Box>
      </Box>
    </Wrapper>
  );
}

export default Duplications;
